import React, { useState, useEffect } from "react";
import {
  useLazyProfilegetQuery,
  useProfileeditMutation,
  useProfiledeleteMutation,
  useProfilepageMutation,  
} from "../../redux/Api/api";

const Personal = () => {
  const [mobilenumber, setMobileNumber] = useState("");
  const [firstname, setFirstName] = useState("");
  const [lastname, setLastName] = useState("");
  const [gender, setGender] = useState("");
  const [address, setAddress] = useState("");
  const [profileEdit, setProfileEdit] = useState(false);
  const [profileId, setProfileId] = useState(null);
  const [loading, setLoading] = useState(true);  
  const [profileget] = useLazyProfilegetQuery();
  const [editProfile] = useProfileeditMutation();
  const [deleteProfile] = useProfiledeleteMutation();
  const [saveProfile] = useProfilepageMutation();  


  const fetchProfile = async () => {
    try {
      setLoading(true);
      
      const userId = localStorage.getItem("userId");
      console.log("Retrieved userId from localStorage:", userId);
  
      if (!userId) {
        console.error("User ID is missing!");
        alert("Error: User ID is missing. Please log in again.");
        return;
      }
  
      const response = await profileget(userId).unwrap(); 
      console.log("Fetched Profile Response:", response); 
  
      const userData = response.personalUser;
  
      if (userData) {
        setProfileId(userData._id);
        setMobileNumber(userData.mobileNumber || "");
        setFirstName(userData.firstName || "");
        setLastName(userData.lastName || "");
        setGender(userData.gender || "");
        setAddress(userData.address || "");
        setProfileEdit(false);
      } else {
        setProfileEdit(true);
      }
    } catch (err) {
      console.error("Error fetching profile:", err);
      alert(`Error: ${err.data?.message || "Something went wrong"}`);
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    fetchProfile();
  }, []);

  const handleSaveSubmit = async (e) => {
    e.preventDefault();
  
    const userId = localStorage.getItem("userId") || "defaultUserId"; 
  
    
    if (!userId) {
      alert("User ID is missing. Please log in again.");
      return;
    }
  
    if (!/^\d{10}$/.test(mobilenumber)) {
      alert("Please enter a valid 10-digit mobile number.");
      return;
    }
  
    const payload = {
      userId, 
      firstName: firstname,
      lastName: lastname,
      gender,
      mobileNumber: mobilenumber,
      address,
    };
  
    try {
      if (profileId) {
        console.log("ahsdfua", payload);
        
        await editProfile({ id: profileId, payload }).unwrap();
        alert("Profile updated successfully!");
      } else {
        const newProfile = await saveProfile(payload).unwrap();
        alert("Profile created successfully!");
        setProfileId(newProfile._id);
      }
      setProfileEdit(false);
      fetchProfile();
    } catch (err) {
      console.error("Error:", err);
      alert(`Error: ${err.data?.message || "Operation failed"}`);
    }
  };
  
  const handleDelete = async () => {
    if (!profileId) {
      alert("No profile to delete.");
      return;
    }

    if (window.confirm("Are you sure you want to delete this profile?")) {
      try {
        await deleteProfile({ id: profileId }).unwrap();
        alert("Profile deleted successfully!");
        setMobileNumber("");
        setFirstName("");
        setLastName("");
        setGender("");
        setAddress("");
        setProfileId(null);
        setProfileEdit(true);
      } catch (err) {
        console.error("Delete Error:", err);
        alert(`Error: ${err.data?.message || "Failed to delete profile"}`);
      }
    }
  };

  return (
    <div className="flex items-center justify-center md:mt-48 mt-48 p-4">
      <div className="w-full max-w-3xl p-4 shadow-lg rounded-md border border-gray-300">
        <h1 className="text-3xl font-bold mb-6">Personal Information</h1>

        {loading ? (
          <p>Loading...</p>
        ) : (
          <>
            {!profileEdit && profileId && (
              <div className="flex space-x-4">
                <button
                  onClick={() => setProfileEdit(true)}
                  className="bg-blue-500 text-white px-12 py-2 rounded hover:bg-blue-600"
                >
                  Edit
                </button>
                <button
                  onClick={handleDelete}
                  className="bg-red-500 text-white px-12 py-2 rounded hover:bg-red-600"
                >
                  Delete
                </button>
              </div>
            )}

            <form onSubmit={handleSaveSubmit}>
              <div className="grid grid-cols-2 gap-4 mt-8">
                <div>
                  <label className="block text-sm font-medium text-gray-500">First Name</label>
                  <input
                    type="text"
                    value={firstname}
                    onChange={(e) => setFirstName(e.target.value)}
                    disabled={!profileEdit}
                    className="mt-2 block w-full px-3 py-4 border border-gray-300"
                    placeholder="First Name"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-500">Last Name</label>
                  <input
                    type="text"
                    value={lastname}
                    onChange={(e) => setLastName(e.target.value)}
                    disabled={!profileEdit}
                    className="mt-2 block w-full px-3 py-4 border border-gray-300"
                    placeholder="Last Name"
                  />
                </div>
              </div>

              <div className="mt-10">
                <label className="block text-sm font-medium text-gray-500">Phone Number</label>
                <input
                  type="text"
                  value={mobilenumber}
                  onChange={(e) => setMobileNumber(e.target.value)}
                  disabled={!profileEdit}
                  className="mt-2 block w-full px-3 py-4 border border-gray-300 shadow-sm"
                  placeholder="Phone Number"
                />
              </div>

              <div className="grid grid-cols-2 gap-4 mt-10">
                <div>
                  <label className="block text-sm font-medium text-gray-500 mb-6">Gender</label>
                  <div className="flex items-center space-x-6">
                    <label className="flex items-center">
                      <input
                        id="male"
                        name="gender"
                        type="radio"
                        value="male"
                        checked={gender === "male"}
                        onChange={() => setGender("male")}
                        disabled={!profileEdit}
                        className="h-4 w-4 text-indigo-600 border-gray-300"
                      />
                      <span className="ml-3 text-sm font-medium text-gray-700">Male</span>
                    </label>
                    <label className="flex items-center">
                      <input
                        id="female"
                        name="gender"
                        type="radio"
                        value="female"
                        checked={gender === "female"}
                        onChange={() => setGender("female")}
                        disabled={!profileEdit}
                        className="h-4 w-4 text-indigo-600 border-gray-300"
                      />
                      <span className="ml-3 text-sm font-medium text-gray-700">Female</span>
                    </label>
                  </div>
                </div>
              </div>

              <div className="mt-10">
                <label className="block text-sm font-medium text-gray-500">Address</label>
                <input
                  type="text"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                  disabled={!profileEdit}
                  className="mt-2 block w-full px-4 py-3 border border-gray-300"
                  placeholder="Address"
                />
              </div>

              {profileEdit && (
                <button type="submit" className="px-8 py-3 mt-6 text-white bg-[#ff5500] rounded-sm">
                  {profileId ? "Save" : "Create"}
                </button>
              )}
            </form>
          </>
        )}
      </div>
    </div>
  );
};
export default Personal;
